export default __webpack_public_path__ + "static/media/1950.fe9d1f44.png";